import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
// routes
import Router from './routes';

// theme
import ThemeProvider from './theme';
// components
import './assets/Styles/global.scss';
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeLocalization from './components/ThemeLocalization';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { ChartStyle } from './components/chart';
import Settings from './components/settings';
import useClearLocalStorage from './hooks/useClearLocalStorage';
import { useLocalStorage } from './hooks/useLocalStorage';
import { networkGetAppInfo } from './network/feed';
import { useFetchProfileInfo } from './network/profile';
import useAdminInfoStore from './store/admin';
import useAppInfoStore from './store/appInfo';
import useProjectInfoStore from './store/project';

// ----------------------------------------------------------------------

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { setAppInfo } = useAppInfoStore();
  const { adminInfo, setProfileDetails } = useAdminInfoStore();

  const { setProjectInfo } = useProjectInfoStore();

  const [applicationDetails] = useLocalStorage('applicationDetails');
  const [savedPage] = useLocalStorage('savedPage');

  useClearLocalStorage();

  const onGetAppInfo = () => {
    networkGetAppInfo()
      .then((res) => {
        setAppInfo(res?.data?.items);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    onGetAppInfo();

    if (applicationDetails) {
      // for adding dynamic item (project sections) to the sidebar
      setProjectInfo(applicationDetails);
    }
  }, []);

  useEffect(() => {
    if (savedPage) {
      const { pageName, pageIndex } = savedPage;

      const parts = location.pathname.split('/');

      if (!searchParams.has('page') && pageName === parts[2] && parts?.length < 3) {
        setSearchParams({ page: pageIndex });
        navigate(`${location?.pathname}${pageIndex ? `?page=${pageIndex}` : ''}`);
      }
    }
  }, [searchParams]);

  const { data: profileInfo } = useFetchProfileInfo();

  useEffect(() => {
    if (adminInfo && profileInfo) {
      setProfileDetails(profileInfo?.data?.items?.[0]);
    }
  }, [adminInfo, profileInfo]);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <MotionLazyContainer>
                <ProgressBarStyle />
                <ChartStyle />
                <Settings />
                <ScrollToTop />
                <Router />
              </MotionLazyContainer>
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
